// import { renderDate, renderTime } from "@intrasync/utils";
import { renderDate } from '@intrasync/utils';
import { renderTime } from '@intrasync/utils';
import { Delete } from '@mui/icons-material';

import React from 'react';
import Button from '../../Button/Button';
import DataGridBodyEditCell from './DataGrid.BodyEditCell';
import DataGridBodyFullGridEditCell from './DataGrid.BodyFullGridEditCell';
import injectStores from '../../RootStore/injectStores';
import { DataGridStore } from 'stores/index';
import RootStore from 'stores/RootStore';
import { DataGridColumnHeader } from 'types/DataGridTypes';

const grayColor = ['#f9f9f9', '#f3f3f3', '#e9e9e9', '#e3e3e3', '#d9d9d9'];
interface DataGridBodyCellProps {
  style: React.CSSProperties;
  onRowClick?: (
    rowData: Record<string, unknown>,
    cellInfo: { [key: string]: unknown; columnIndex: number; rowIndex: number }
  ) => void;
  columnIndex: number;
  rowIndex: number;
  enableHover?: boolean;
  enableInlineEdit?: boolean;
  enableFullGridEdit?: boolean;
  onSubmitEdits?: (
    uniqueKey: string | number,
    editData: Record<string, object>,
    rootStore?: RootStore
  ) => void;
  namespaceId: string;
  onRemove?: (
    data: { [key: string]: string | number },
    rootStore?: RootStore
  ) => void | Promise<void>;
  dataGridStore?: DataGridStore;
}

class DataGridBodyCell extends React.PureComponent<DataGridBodyCellProps> {
  // constructor(props: DataGridBodyCellProps) {
  //   super(props);
  //   makeObservable(this, {
  //     cellUniqueKey: computed,
  //     cellHeader: computed,
  //     cellKey: computed,
  //     cellDataType: computed,
  //     cellRowData: computed,
  //     cellValue: computed,
  //     cellRender: computed,
  //     isHighlightedRow: computed,
  //     isHighlightedColumn: computed,
  //     isHighlightedCell: computed,
  //     cellEditValue: computed,
  //     currentStore: computed,
  //     defaultValue: computed,
  //   });
  // }

  setEditMode = () => {
    if (this.cellUniqueKey && this.currentStore) {
      this.currentStore.setEditData(String(this.cellUniqueKey), {
        [this.cellKey]: this.cellValue,
      });
    }
  };

  handleRowClick = () => {
    const { onRowClick, columnIndex, rowIndex } = this.props;
    if (this.cellRowData && onRowClick) {
      return onRowClick(this.cellRowData as Record<string, unknown>, {
        [this.cellKey]: this.cellValue,
        columnIndex,
        rowIndex,
      });
    }
  };

  get currentStore() {
    const { dataGridStore, namespaceId } = this.props;
    if (!dataGridStore) return null;
    return dataGridStore.namespaces[namespaceId];
  }

  get cellUniqueKey() {
    return this.cellRowData?.[this.currentStore?.uniqueKey ?? ''];
  }

  get cellHeader() {
    const { columnIndex } = this.props;
    return this.currentStore?.currentColumnHeaders[
      columnIndex
    ] as DataGridColumnHeader;
  }

  get cellKey() {
    return this.cellHeader?.key || '';
  }

  get cellDataType() {
    return this.cellHeader?.dataType || 'string';
  }

  get cellRowData() {
    const { rowIndex } = this.props;
    return this.currentStore?.currentRows?.[rowIndex];
  }

  get cellValue() {
    return this.cellRowData?.[this.cellKey] || '';
  }

  get defaultValue() {
    // if (this.cellHeader?.emptyCells) return '';

    if (this.cellDataType === 'number') return 0;
    if (this.cellDataType === 'date') return 'Not Set';
    if (this.cellDataType === 'time') return 'Not Set';
    if (this.cellDataType === 'boolean') return 'No';

    return '';
  }

  get cellRender() {
    // console.log('this.cellValue', this.cellValue);
    // console.log('this.cellDataType', this.cellDataType);
    if (this.cellDataType === 'date') {
      if (!this.cellValue || this.cellValue === '1970-01-01')
        return this.defaultValue;

      return renderDate(String(this.cellValue));
    }

    if (this.cellDataType === 'time') {
      if (!this.cellValue) return this.defaultValue;

      return renderTime(String(this.cellValue));
    }

    if (this.cellDataType === 'number') {
      if (!parseInt(String(this.cellValue))) {
        return this.defaultValue;
      }

      return this.cellValue;
    }

    if (this.cellDataType === 'boolean') {
      if (!this.cellValue || this.cellValue === 'False') {
        return this.defaultValue;
      }

      return 'Yes';
    }

    return this.cellValue;
  }

  get cellEditValue() {
    if (this.cellUniqueKey && this.currentStore?.editData) {
      const currentEdits = this.currentStore.editData[String(this.cellUniqueKey)];
      if (currentEdits) {
        const editValue = currentEdits[this.cellKey];
        return editValue;
      }
    }
    return null;
  }

  get isHighlightedRow() {
    const { rowIndex } = this.props;
    return rowIndex === this.currentStore?.currentCellHover?.rowIndex;
  }

  get isHighlightedColumn() {
    const { columnIndex } = this.props;
    return columnIndex === this.currentStore?.currentCellHover?.columnIndex;
  }

  get isHighlightedCell() {
    return this.isHighlightedRow && this.isHighlightedColumn;
  }

  render() {
    const {
      style,
      onRowClick,
      columnIndex,
      rowIndex,
      enableHover,
      enableInlineEdit,
      enableFullGridEdit,
      onSubmitEdits,
      namespaceId,
      onRemove,
    } = this.props;

    let backgroundColor = 'white';

    if (enableHover && (this.isHighlightedRow || this.isHighlightedColumn)) {
      backgroundColor = grayColor[13];
    }

    if (enableHover && this.isHighlightedCell) {
      backgroundColor = grayColor[8];
    }

    let enableCursor = enableInlineEdit;

    if (
      this.cellHeader?.disableEdit ||
      (enableInlineEdit && typeof style.width === 'number' && style.width < 100)
    ) {
      enableCursor = false;
      backgroundColor = grayColor[4];
      if (this.isHighlightedCell) {
        backgroundColor = grayColor[3];
      }
    }

    if (
      this.currentStore?.removeColumnEnabled &&
      this.cellKey === 'remove' &&
      onRemove
    ) {
      return (
        <div
          style={{
            ...style,
            border: '1px solid grey',
            textAlign: 'center' as const,
            textWrap: 'wrap',
            width: typeof style.width === 'number' ? style.width - 2 : 'auto',
            height:
              typeof style.height === 'number' ? style.height - 2 : 'auto',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Button
            justIcon
            tooltip="Remove Item"
            color="danger"
            onClick={() => {
              if (this.currentStore?.rootStore) {
                // Use type assertion to convert to the expected RootStore type
                const rootStore = this.currentStore.rootStore as unknown as import('stores/RootStore').default;
                return onRemove(
                  {
                    [this.currentStore.uniqueKey ?? '']: String(this.cellUniqueKey),
                  },
                  rootStore
                );
              }
            }}
          >
            <Delete />
          </Button>
        </div>
      );
    }

    if (onRowClick) {
      enableCursor = true;
    }

    const cellStyles = {
      border: '1px solid grey',
      textAlign: 'center',
      textWrap: 'wrap',
      cursor: enableCursor ? 'pointer' : 'cursor',
      backgroundColor: backgroundColor,
    };

    if (enableFullGridEdit && !this.cellHeader?.disableEdit) {
      const editCellHeight =
        typeof style.height === 'number' ? style.height - 2 : 0;
      const editCellWidth =
        typeof style.width === 'number' ? style.width - 2 : 0;

      const divStyle = {
        ...style,
        ...cellStyles,
        height: editCellHeight,
        width: editCellWidth,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      };
      return (
        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        <div style={divStyle}>
          <DataGridBodyFullGridEditCell
            cellUniqueKey={this.cellUniqueKey}
            cellDataType={this.cellDataType}
            cellEditKey={this.cellKey}
            cellEditValue={this.cellEditValue}
            cellHeight={editCellHeight}
            cellWidth={editCellWidth}
            cellActualValue={this.cellValue}
            onSubmitEdits={onSubmitEdits}
            cellKey={this.cellKey}
            enableFullGridEdit={enableFullGridEdit}
            cellHeader={this.cellHeader}
            namespaceId={namespaceId}
          />
        </div>
      );
    }

    if (
      !enableFullGridEdit &&
      (this.cellEditValue || this.cellEditValue === '') &&
      !this.cellHeader?.disableEdit
    ) {
      const editCellHeight =
        (typeof style.height === 'number' ? style.height : 0) - 4;
      const editCellWidth =
        (typeof style.width === 'number' ? style.width : 0) - 4;
      return (
        <div
          // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
          style={{
            ...style,
            ...cellStyles,
            border: '2px solid orange',
            height: editCellHeight,
            width: editCellWidth,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          onMouseOver={() =>
            this.currentStore?.setCurrentCellHover(columnIndex, rowIndex)
          }
        >
          <DataGridBodyEditCell
            cellUniqueKey={this.cellUniqueKey}
            cellDataType={this.cellDataType}
            cellEditKey={this.cellKey}
            cellEditValue={this.cellEditValue}
            cellHeight={editCellHeight}
            cellWidth={editCellWidth}
            cellActualValue={this.cellValue}
            onSubmitEdits={onSubmitEdits}
            cellKey={this.cellKey}
            enableFullGridEdit={enableFullGridEdit}
            cellHeader={this.cellHeader}
            namespaceId={namespaceId}
          />
        </div>
      );
    }

    return (
      <div
        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        style={{
          ...style,
          ...cellStyles,
          border: '1px solid grey',
          width: (typeof style.width === 'number' ? style.width : 0) - 2,
          height: typeof style.height === 'number' ? style.height - 2 : 'auto',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          whiteSpace: 'nowrap' /* Keep text on a single line */,
          overflow: 'hidden' /* Hide any overflowing text */,
          textOverflow: 'ellipsis' /* Add the ellipsis */,
        }}
        onClick={() => {
          if (onRowClick) {
            return this.handleRowClick();
          }

          if (
            enableInlineEdit &&
            typeof style.width === 'number' &&
            style.width < 100
          ) {
            console.warn('Edit cells need to be at least 100 pixels to fit');
          }

          if (
            enableInlineEdit &&
            typeof style.width === 'number' &&
            style.width >= 100
          ) {
            return this.setEditMode();
          }

          return console.log(
            'Clicking the cell with no options enabled will fallout here'
          );
        }}
        onMouseOver={() =>
          this.currentStore?.setCurrentCellHover(columnIndex, rowIndex)
        }
      >
        {`${this.cellRender}`}
      </div>
    );
  }
}

const EnhancedDataGridBodyCell = injectStores(DataGridBodyCell);
export default EnhancedDataGridBodyCell;
